//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Bromage_info',
}



// WEBPACK FOOTER //
// ./src/pages/formulasInfo/Anae/Chart_Bromage_info.vue